import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useAssignmentDelete = () => {
  const createAssignmentDeleteRequest = useCallback((id) => {
    return new Request(`${API_BASE_URL}/api/v3/assignment/${id}/`, {
      method: "DELETE",
    });
  }, []);
  return useRestMutation(createAssignmentDeleteRequest);
};

export default useAssignmentDelete;
